import * as service from "../service";
import { store } from "../../store";

/**
 * Fetch a page of notifications for the current user.
 * Backend: GET /api/notification/getNotifications/getNotifications
 */
export const GetNotificationsAPI = async (page: number = 1) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/notification/getNotifications/getNotifications",
      {
        user_id: user?.id,
        society_id: user?.society_id,
        page,
      },
    );
    return resp;
  } catch (err) {
    console.error(`GetNotificationsAPI ${err}`);
    return { status: -1, resp: err };
  }
};
